// extracted by mini-css-extract-plugin
export default {"container":"KYCLevel2_container__1ZPKv","main-1":"KYCLevel2_main-1__2RauY"};